export default function Testimonial() {
  return (
    <section class="testimonial">
      <div class="wrap">
        <blockquote>
          <p>I used to lose two hours every month just making an invoice and chasing payments. Now it takes five minutes.</p>
          <footer>
            <span class="q-name">Sara Abdullah</span>
            <span class="q-role">UI/UX designer, freelancer</span>
          </footer>
        </blockquote>
      </div>
    </section>
  );
}